import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, { icon: "images/papsi_error_icon.svg" }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "w-full h-full flex bg-theme-primary" }, [
        _createElementVNode("span", {
          textContent: 'PAGE NOT FOUND',
          class: "text-7xl m-auto text-theme-secondary font-bold"
        })
      ], -1)
    ])),
    _: 1,
    __: [0]
  }))
}